import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  text: {
    fontSize: 5,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  table2: {
    display: 'table',
    width: '50%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 50
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableColHeader: {
    width: '14.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0',
    padding: 5
  },
  tableCol: {
    width: '12.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 5
  },
  tableCellHeader: {
    fontSize: 7,
    fontWeight: 'bold'
  },
  tableCell: {
    fontSize: 10
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const CollectionSummaryReport = ({ data = { services: [] } }) => {
  console.log('Data:', data);

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Collection Summary Report ">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '50%', height: '50px', marginBottom: 20, marginLeft: '170px' }}
            />
            <View style={styles.row}>
              <Text style={styles.text}>User Wise Collection Summary</Text>
            </View>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <View
                  style={{
                    width: '9.28%',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#bfbfbf',
                    backgroundColor: '#f0f0f0',
                    padding: 5
                  }}
                >
                  <Text style={styles.tableCellHeader} content="Sr No." />
                </View>
                <View
                  style={{
                    width: '10.28%',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#bfbfbf',
                    backgroundColor: '#f0f0f0',
                    padding: 5
                  }}
                >
                  <Text style={styles.tableCellHeader} content="Bill Date" />
                </View>
                <View
                  style={{
                    width: '9.28%',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#bfbfbf',
                    backgroundColor: '#f0f0f0',
                    padding: 5
                  }}
                >
                  <Text style={styles.tableCellHeader} content="type" />
                </View>
                <View
                  style={{
                    width: '15.28%',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#bfbfbf',
                    backgroundColor: '#f0f0f0',
                    padding: 5
                  }}
                >
                  <Text style={styles.tableCellHeader} content="Patient Name" />
                </View>
                <View
                  style={{
                    width: '11.28%',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#bfbfbf',
                    backgroundColor: '#f0f0f0',
                    padding: 5
                  }}
                >
                  <Text style={styles.tableCellHeader} content="Uhid No." />
                </View>
                <View
                  style={{
                    width: '11.28%',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#bfbfbf',
                    backgroundColor: '#f0f0f0',
                    padding: 5
                  }}
                >
                  <Text style={styles.tableCellHeader} content="Adm No." />
                </View>
                <View
                  style={{
                    width: '12.28%',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#bfbfbf',
                    backgroundColor: '#f0f0f0',
                    padding: 5
                  }}
                >
                  <Text style={styles.tableCellHeader} content="Paymode" />
                </View>
                <View
                  style={{
                    width: '10.28%',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#bfbfbf',
                    backgroundColor: '#f0f0f0',
                    padding: 5
                  }}
                >
                  <Text style={styles.tableCellHeader} content="Txn No." />
                </View>
                <View
                  style={{
                    width: '12.28%',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#bfbfbf',
                    backgroundColor: '#f0f0f0',
                    padding: 5
                  }}
                >
                  <Text style={styles.tableCellHeader} content="Consultant" />
                </View>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader} content="Services" />
                </View>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader} content="Panel" />
                </View>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader} content="Bill Amt." />
                </View>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader} content="Dis Amt." />
                </View>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader} content="Recd. Amt." />
                </View>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader} content="Bal. Amt." />
                </View>
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader} content="Username" />
                </View>
              </View>
              {data.services &&
                data.services.map((service, index) => (
                  <View key={index} style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell} content={index + 1} />
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell} content={service.service} />
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell} content={service.quantity} />
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell} content={service.rate} />
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell} content={service.amount} />
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell} content={service.disc_amt} />
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell} content={0} />
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell} content={service.net_amt} />
                    </View>
                  </View>
                ))}
            </View>
            <View style={styles.table2}>
              <View style={styles.tableRow}>
                <View
                  style={{
                    width: '20.28%',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#bfbfbf',
                    backgroundColor: '#f0f0f0',
                    padding: 5
                  }}
                >
                  <Text style={styles.tableCellHeader} content="Username" />
                </View>
                <View
                  style={{
                    width: '20.28%',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#bfbfbf',
                    backgroundColor: '#f0f0f0',
                    padding: 5
                  }}
                >
                  <Text style={styles.tableCellHeader} content="Cash" />
                </View>
                <View
                  style={{
                    width: '20.28%',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#bfbfbf',
                    backgroundColor: '#f0f0f0',
                    padding: 5
                  }}
                >
                  <Text style={styles.tableCellHeader} content="Debit Card" />
                </View>
                <View
                  style={{
                    width: '20.28%',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#bfbfbf',
                    backgroundColor: '#f0f0f0',
                    padding: 5
                  }}
                >
                  <Text style={styles.tableCellHeader} content="UPI" />
                </View>
                <View
                  style={{
                    width: '20.28%',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#bfbfbf',
                    backgroundColor: '#f0f0f0',
                    padding: 5
                  }}
                >
                  <Text style={styles.tableCellHeader} content="Total" />
                </View>
              </View>
              {data.services &&
                data.services.map((service, index) => (
                  <View key={index} style={styles.tableRow}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell} content={index + 1} />
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell} content={service.service} />
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell} content={service.quantity} />
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell} content={service.rate} />
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell} content={service.amount} />
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell} content={service.disc_amt} />
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell} content={0} />
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell} content={service.net_amt} />
                    </View>
                  </View>
                ))}
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default CollectionSummaryReport;
